// extracted by mini-css-extract-plugin
module.exports = {"delete-icon":"styles_delete-icon__3To6K"};